import React from 'react';
import { TableCell, Typography, TableRow } from '@mui/material';
import PropTypes from 'prop-types';

const AppTableNoData = ({ colSpan, message, loading }) => {
  if (loading) return null;
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center">
        <Typography sx={{ padding: 2 }}>
          {message || 'No data found'}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default AppTableNoData;
AppTableNoData.propTypes = {
  loading: PropTypes.bool,
  colSpan: PropTypes.number,
  message: PropTypes.string,
}